import $ from 'jquery';
import wc from './wc';
import sliders from './sliders';
import filters from './filters';

$(document).ready(function(){ 
    wc.init();
    wc.clickModal();
    sliders.init();
    sliders.initWrapAround();
    sliders.initHeroSlider();
    sliders.initSliderContain();
    filters.init();

    $('.burger').click((e) => {
        $('body').css('overflow','hidden');
        $(e.currentTarget).toggleClass('open');
        $('.header__menu').toggleClass('show');
        $('.header__top__menu .lang').toggleClass('show');
        if( $(e.currentTarget).hasClass('open') ){
            $('body').css('overflow','hidden');
        }
        else{
            $('body').css('overflow','auto');
        }
    });

    
    $(".newsletter__gdpr .input-field input").click( function(){
        if( $(this).is(':checked') ){
            $(".newsletter__button input").prop('disabled',false);
        }
        else{
            $(".newsletter__button input").prop('disabled',true);
        }
    });

});